<template>
  <div class="datadownload-content tc">
    <banner clazz="datadownload-banner" url="DataDownload"></banner>
    <div class="datadownload-section1 dib tl">
      <div class="section1-leftlist dib">
        <div class="selectlist-header tc">资料下载</div>
        <div class="selectlist-cell tl" :value="item.id"
             :class="(item.id === listValue)? 'is-active': ''"
             @click="clickCell(item.id)"
             v-for="item in downloadList">{{item.name}}</div>
      </div>
      <div class="section1-rightcontent dib">
        <div class="content-cell" v-for="item in cellList">
          <div class="icon-container dib">
            <img class="cell-icon" v-lazy="$global.globalPath + item.img" alt="图片地址错误" />
          </div>
          <div class="cell-content dib">
            <div class="content-title">
              <div class="title-icon dib"></div>
              <h1 class="title-misc dib">{{item.title}}</h1>
            </div>
            <div class="content-misc">
              {{item.describe}}
            </div>
            <a class="content-footer db tr" :href="getDetailLink(item.id)">
              <div class="footer-link dib">查看详情</div>
              <img class="footer-icon" src="../../assets/img/dataDownload/footer-icon.png" alt="查看详情"/>
            </a>
          </div>
        </div>
        <div class="nodata-misc tc" v-if="cellList.length === 0">暂无数据</div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '../common/banner.vue'

export default {
  name: 'dataDownload',
  metaInfo () {
    return {
      title: this.$seo.datadownload.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.datadownload.keywords
      },
      {
        name: 'description',
        content: this.$seo.datadownload.description
      }]
    }
  },
  components: {
    banner
  },
  data () {
    return {
      downloadList: [],
      listValue: '1',
      listTest: {
        title: 'SRM资源',
        icon: require('../../assets/img/dataDownload/cell-icon1.png'),
        content: '甄云提供全流程开发运维服务，帮助企业内部IT能力从面向工具到面向服务的转型，采用前沿技术快' +
          '速迭代，适应供应链业务前沿需求，涵盖服务器、存储甄云提供全流程开发运维服务，帮助企业内部IT能力从面' +
          '向工具到面向服务的转型，采用前沿技术快速迭代，适应供应链业务前'
      },
      cellList: []
    }
  },
  created () {
    this.getCatalogue(() => {
      this.listValue = this.$route.query.list || this.listValue
      this.clickCell(this.listValue)
    })
  },
  methods: {
    clickCell (num) {
      this.listValue = num
      this.cellList = []
      this.$api.post('/document/content_list', { cid: num }, (r) => {
        if (r.code === 0) {
          this.cellList = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    getCatalogue (callback) {
      this.$api.post('/document/catalogue', {}, (r) => {
        if (r.code === 0) {
          this.downloadList = r.data
          this.listValue = this.downloadList[0].id
          if (callback) {
            callback(r.data)
          }
        } else {
          this.$message.error(r.message)
        }
      })
    },
    goDetail (num) {
      this.$router.push({
        name: 'DataDownloadDetail',
        query: {
          list: this.listValue,
          item: num
        }
      })
    },
    getDetailLink (num) {
      let routeUrl = this.$router.resolve({
        name: 'DataDownloadDetail',
        query: {
          list: this.listValue,
          item: num
        }
      })
      let result = this.$global.frontPath + routeUrl.href
      return result
    }
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/dataDownload.scss";
</style>



// WEBPACK FOOTER //
// dataDownload.vue?1bebbd7c